<template>
    <div class="container d-flex justify-content-center">
        <div class="d-flex flex-column" style="max-width: 1021px; gap: 10px">
            <template v-for="(question, index) in store.questions">
                <div class="d-flex flex-column justify-content-start align-items-md-center" style="gap: 10px">
                    <div ref="questionElements" class="flex-grow-1 step-title cursor-pointer" :class="{'text-muted': store.currentQuestion !== index+1}" @click="store.currentQuestion=index+1">
                        {{index+1}}. {{question.question}}
                    </div>

                    <div v-if="store.currentQuestion === index+1" class="w-100">
                        <component :is="question.component" class="fade-in"></component>

                        <div ref="nav-buttons" class="fade-in">
                            <div class="spacer-32"></div>

                            <div class="d-flex justify-content-center justify-content-sm-end gap-2">
                                <button type="button" class="btn btn-outline-secondary text-uppercase" style="min-width: 150px" v-if="store.currentQuestion > 1" @click="store.currentQuestion--">{{$trans('storefront::flexible_packaging.previous')}}</button>
                                <button type="button" class="btn btn-secondary text-uppercase" style="min-width: 150px" @click="store.currentQuestion++">{{$trans('storefront::flexible_packaging.next')}}</button>
                            </div>

                            <div class="spacer-64"></div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import {useFlexiblePackagingStore} from "../../js/store";
import PlowSizeSelector from "./pouch-size/PlowSizeSelector";
import QuadSizeSelector from "./pouch-size/QuadSizeSelector";
import SidePlowSizeSelector from "./pouch-size/SidePlowSizeSelector";
import HoleInPouch from "./hole-in-pouch/HoleInPouch";
import Zipper from "./zipper/Zipper";
import TearNotch from "./tear-notch/TearNotch";
import RoundedCorners from "./rounded-corners/RoundedCorners";
import SealWidth from "./seal-width/SealWidth";
import PouchValve from "./pouch-valve/PouchValve";
import Material from "./material/Material";
import { ref, watch } from 'vue';

export default {
    components: {
        Material,
        PouchValve,
        SealWidth,
        RoundedCorners,
        TearNotch, Zipper, HoleInPouch, SidePlowSizeSelector, QuadSizeSelector, PlowSizeSelector},
    setup() {
        const store = useFlexiblePackagingStore();
        return {
            store: store,
        }
    },
    mounted() {
        let app = this;
        watch(() => app.store.currentQuestion, () => {
            let el = $(app.$refs['nav-buttons']);
            el.removeClass('fade-in');
            el.addClass('fade-in');

            if (app.store.currentQuestion > 8) {
                app.store.currentQuestion = 8;

                app.store.nextStep();
            } else {
                app.scrollToQuestion();
            }
        });

        app.scrollToQuestion();
    },
    methods: {
        scrollToQuestion() {
            let element = this.$refs.questionElements[this.store.currentQuestion-1];
            window.$scrollToElement({element, offset: -120})
        }
    }
}
</script>

<style lang="scss" scoped>
.text-muted {
    color: #939393 !important;
}
</style>
